<template>
  <detail-layout ref="layout" :tableCfg="tableCfg">
    <template slot="FormLayout" scope="props">
      <b-form ref="form" class="col-md-6 offset-md-2" autocomplete="off">
        <div v-if="dataValid" >
          <detail-field label="Intake" field="intake" :optionListApiUrl="'/contracts_intake/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Scholarship" field="scholarship_id" :optionListApiUrl="'/scholarships/choice/'" :rec="props.rec" :isReadOnly="isReadOnly" vvalidate="required" :validator="validator"/>
          <detail-field label="Registration Fee" field="registration_fee_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field label="Participation Fee Y1" field="participationfee1_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field label="Participation Fee Y2" field="participationfee2_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field label="Adminstration Fee Y1" field="administrationfee1_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field label="Adminstration Fee Y2" field="administrationfee2_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
          <detail-field label="Monthly Allowance" field="administrationfee2_amount" :rec="props.rec" :isReadOnly="isReadOnly" type="money" vvalidate="ok" :validator="validator"/>
        </div>
      </b-form>
    </template>
  </detail-layout>
</template>

<script>
import DetailMixin from '../../components/DetailMixin'
import FieldDefs from './FieldDefs.js'

export default {
  name: 'program_detail',
  mixins: [DetailMixin],
  data () {
    return {
      tableCfg: FieldDefs
    }
  },
  methods: {
  }
}
</script>



// WEBPACK FOOTER //
// Detail.vue?610f542c